import { DocumentationPriorityEnum } from "@altertec_gparn/lib";
import { Expose } from "class-transformer";

export class UpdateProjectHasVehicleDto {
  @Expose()
  documentationPriority: DocumentationPriorityEnum;
}
